<template>
  <div class="lite-switcher" @click="onClick">
    <div
      :class="{
          'switch': true,
          'lite': true,
          'switch-active': !!value
        }"
    >Lite</div>
    <div
      :class="{
          'switch': true,
          'pro': true,
          'switch-active': !value
        }"
    >Pro</div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  methods: {
    onClick() {
      this.$emit("input", !this.value);
    }
  }
};
</script>

<style scoped>
.lite-switcher {
  background: #ededed;
  border-radius: 0.3vh;
  display: flex;
  padding: 0.2vh;
  height: 3vh;
  align-self: center;
  user-select: none;
}

.switch {
  text-align: center;
  border-radius: 0.3vh;
  font-size: 1.8vh;
  padding: 0.2vh 2vh;
  cursor: pointer;
  align-self: center;
  color: #464646;
}
 

.switch-active {
  color: #ededed;
  background: #464646;
}

 .lite.switch-active {
  color: #aeccc6;
  background: #464646;
}
</style>